import InvalidUrl from "../routes/InvalidUrl";

const Common = [{ path: "/invalidUrl", component: InvalidUrl }];

export default Common;
